import { MongoObservable } from 'meteor-rxjs';
import { Organisation } from '../models/organisation';

export const Organisations = new MongoObservable.Collection<Organisation>(
  'organisations',
);

Organisations.allow({
  insert: function () {
    return false;
  },
  update: function () {
    return false;
  },
  remove: function () {
    return false;
  },
});
